import axios from "axios";
import AddToCart from "./AddToCart.svelte";

const svelteAddToCarts = () =>
  document.querySelectorAll(".svelte-add-to-cart:not([data-svelted])");
window.initSvelteAddToCarts = () => {
  const targets = svelteAddToCarts();
  targets &&
    targets.forEach((target) => {
      target.setAttribute("data-svelted", true);
      const props = {
        id: target.getAttribute("data-id"),
        image: target.getAttribute("data-image") || null,
        max: target.getAttribute("data-max"),
        basketMode: target.getAttribute("data-basket-mode") || false,
        axios,
      };
      target.removeAttribute("hidden");
      new AddToCart({
        target,
        props,
      });
    });
};
